/* eslint-disable import/prefer-default-export */
import { NextAppRoute } from './NextAppRoute'
import { NextAppNavigation, NextAppRouteDef } from './types'

export function createNavigation<Routes extends readonly NextAppRouteDef[], T extends string>(
  routes: Routes,
  basePath?: T
) {
  return routes.reduce((acc, { name, path, subroutes }) => {
    const currentPath = basePath ? `${basePath}${path}` : path

    acc[name] = {
      route: new NextAppRoute({ path, basePath }),

      ...(typeof subroutes !== 'undefined' && {
        ...createNavigation(subroutes, currentPath),
      }),
    }

    return acc
  }, {} as NextAppNavigation<Routes>)
}
